/*
  Scale · Cart upsell
  Adds an upsell product to the cart and re-renders Dawn's cart drawer in place,
  using the same Section Rendering response Dawn's own product form uses.
*/
if (!customElements.get('scale-cart-upsell')) {
  customElements.define(
    'scale-cart-upsell',
    class ScaleCartUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', (event) => this.onSubmit(event));
      }

      async onSubmit(event) {
        const form = event.target.closest('[data-upsell-form]');
        if (!form) return;
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];

        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }],
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();
          if (state.status) throw new Error(state.description || state.message);

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'scale-cart-upsell', cartData: state });
          }
          cartDrawer?.renderContents(state);
        } catch (error) {
          console.error(error);
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      }
    }
  );
}
